module.exports = __webpack_public_path__ + "8458a643928340664d97ce947cdc71d7.woff";